import {useEffect} from 'react'
import {useMarkerAndDiffNavigationActions} from '../stores/selectors'

/**
 * Hook that listens for hashchange events and syncs the URL hash with the store state.
 * This enables browser back/forward navigation to navigate to the correct comment or annotation.
 *
 * Note: This hook should only be used once in the component tree, eg) in
 * DiffComparisonViewer, so it works for both single file mode and normal mode.
 */
export function useHashNavigation(): void {
  const {handleHashUpdate} = useMarkerAndDiffNavigationActions()

  useEffect(() => {
    const onHashChange = () => {
      handleHashUpdate()
    }

    // Initial call to handle the hash if present on page load
    handleHashUpdate()

    // Listen for hash changes (forward and back button navigation)
    window.addEventListener('hashchange', onHashChange)

    return () => {
      window.removeEventListener('hashchange', onHashChange)
    }
  }, [handleHashUpdate])
}
